import { PackageProviderIcon } from 'components/shared/ppoints/PackageProviderIcon';
import { SettingUrls } from 'constants/SettingsUrls';
import { PackageProviderName } from 'data/ppoints/constants';
import { useProviderNavigation } from 'features/settings/components/ppoints/shipping-provider/hooks/useProviderNavigation';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import PackageProviderService from 'services/settings/ppoints/PackageProviderService';

const MAX_VISIBLE = 3;

interface ActiveProviderLogosProps {
    providers: PackageProviderName[];
    /** Country to open each provider's settings page in */
    countryByProvider: Partial<Record<PackageProviderName, string>>;
}

// The active carriers' logos, each opening that carrier's settings page; past the first 3, the rest are
// summed up in a "+N" block of the same size that opens the carriers list. Without any active carrier,
// a "No carrier yet" line instead.
export const ActiveProviderLogos: React.FC<ActiveProviderLogosProps> = ({ providers, countryByProvider }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { goToProvider } = useProviderNavigation();

    // Same look as the card's "No orders yet"
    if (!providers.length) {
        return (
            <div className="py-4 text-body-md text-text-subdued">
                {t('DASHBOARD.PLAN_OVERVIEW_DETAILS.CARRIERS.NO_CARRIER_YET')}
            </div>
        );
    }

    const visible = providers.slice(0, MAX_VISIBLE);
    const hiddenCount = providers.length - visible.length;

    return (
        <div className="flex items-center gap-3 py-1.5">
            {visible.map((provider) => (
                <button
                    key={provider}
                    type="button"
                    className="cursor-pointer rounded-lg"
                    aria-label={PackageProviderService.getDisplayName(provider) || provider}
                    onClick={() => goToProvider(provider, countryByProvider[provider])}
                >
                    <PackageProviderIcon provider={provider} size="small" />
                </button>
            ))}
            {hiddenCount > 0 && (
                <button
                    type="button"
                    className="flex size-10 cursor-pointer items-center justify-center rounded-lg bg-[rgba(243,243,243,1)]"
                    onClick={() => navigate(SettingUrls.shippingProviders)}
                >
                    <s-text color="subdued">+{hiddenCount}</s-text>
                </button>
            )}
        </div>
    );
};
